









declare const $: any;

import Vue from 'vue';
export default Vue.extend({
    data() {
        return {
            params: null,
        };
    },
    computed: {
        referrals() {
            const me: any = this;
            return me.params.data ? me.params.data.referralsCount : '';
        },
    },
    methods: {
        showReferralsModal() {
            this.params.context.parentComponent.openReferralsModal(
                (this as any).params.data.id
            );
        },
    },
});
